import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { ArrowLeft, LogOut } from 'lucide-react';
import SimulateurAmzCosmFr from '@/components/simulateurs/SimulateurAmzCosmFr';

const SESSION_KEY = 'admin_authenticated';

export default function AdminSimulateurAmzCosmFr() {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) !== 'true') {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    navigate('/admin');
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Simulateur AMZ CW.Fr - Cosmos Wave</title>
      </Helmet>
      <div className="min-h-screen bg-background">
        <div className="border-b bg-card">
          <div className="container mx-auto px-2 sm:px-4 py-3 sm:py-4">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
              <div className="flex items-center gap-2 sm:gap-4 min-w-0">
                <Button variant="ghost" size="sm" asChild className="shrink-0">
                  <Link to="/admin/simulateurs">
                    <ArrowLeft className="w-4 h-4" />
                    <span className="hidden sm:inline ml-2">Retour aux simulateurs</span>
                  </Link>
                </Button>
                <div className="min-w-0">
                  <h1 className="text-base sm:text-xl font-bold bg-gradient-to-r from-[#a2cc3a] to-[#7da82f] bg-clip-text text-transparent truncate">
                    CWLab : Simulateurs & Outils
                  </h1>
                  <p className="text-xs sm:text-sm text-orange-500 font-medium truncate">
                    Outils internes
                  </p>
                </div>
              </div>
              <Button variant="outline" size="sm" onClick={handleLogout} className="shrink-0 self-end sm:self-auto">
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline ml-2">Déconnexion</span>
              </Button>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 py-6">
          <SimulateurAmzCosmFr />
        </div>
      </div>
    </>
  );
}
